<!-- Mobile: Tab-based layout, Desktop: Side-by-side -->
<div class="flex h-full flex-col overflow-hidden md:flex-row">
  <!-- Mobile Tab Navigation (visible only on mobile) -->
  <div class="flex shrink-0 border-b border-gray-200 dark:border-gray-700 md:hidden">
    <button
      type="button"
      class="flex-1 px-4 py-3 text-sm font-medium transition-colors"
      [class.border-b-2]="activeTab() === 'unassigned'"
      [class.border-primary-500]="activeTab() === 'unassigned'"
      [class.text-primary-600]="activeTab() === 'unassigned'"
      [class.text-gray-500]="activeTab() !== 'unassigned'"
      (click)="setActiveTab('unassigned')"
    >
      {{ 'routing.SUB_ROUTE_PARTNERS.LAYOUT.TAB_UNASSIGNED' | t }}
    </button>
    <button
      type="button"
      class="flex-1 px-4 py-3 text-sm font-medium transition-colors"
      [class.border-b-2]="activeTab() === 'assigned'"
      [class.border-primary-500]="activeTab() === 'assigned'"
      [class.text-primary-600]="activeTab() === 'assigned'"
      [class.text-gray-500]="activeTab() !== 'assigned'"
      (click)="setActiveTab('assigned')"
    >
      {{ 'routing.SUB_ROUTE_PARTNERS.LAYOUT.TAB_ASSIGNED' | t }}
    </button>
  </div>

  <!-- Unassigned Sidebar -->
  <div
    class="h-full flex-1 overflow-hidden md:w-[30%] md:min-w-[280px] md:max-w-[400px] md:flex-none md:border-r md:border-gray-200 md:dark:border-gray-700"
    [class.hidden]="activeTab() !== 'unassigned'"
    [class.md:block]="true"
  >
    <app-unassigned-partners-sidebar />
  </div>

  <!-- Assigned Panel -->
  <div
    class="h-full min-w-0 flex-1 overflow-hidden"
    [class.hidden]="activeTab() !== 'assigned'"
    [class.md:block]="true"
  >
    <app-assigned-partners-panel />
  </div>
</div>
